module.exports = __webpack_public_path__ + "img/cwell10.e9aba789.jpg";